import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';

const styles = (theme) => {
    return {
        button: {
            position: 'relative',
            width: 82,
            height: 82,
            borderColor: theme.palette.common.transparent,
            borderWidth: 1,
            borderStyle: 'solid',
            textAlign: 'center',
            cursor: 'pointer',
            display: 'inline-block',
            '&:hover': {
                borderColor: theme.palette.primary.lightBorder,
            }
        },
    };
}

class AppButton extends Component {
    render = () => {
        const {classes} = this.props;

        return (
            <div
                className={classes.button}
                onClick={this._handleClick}
            >
                {this.props.children}
            </div>
        );
    }

    _handleClick = (e) => {
        if (this.props.onClick) {
            this.props.onClick(e, this.props.value);
        }
    }
}

AppButton.propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.any.isRequired,
}

export default withStyles(styles)(AppButton);
